import { render, staticRenderFns } from "./PayoutDetails.vue?vue&type=template&id=12829677&scoped=true"
import script from "./PayoutDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PayoutDetails.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayoutDetails.vue?vue&type=style&index=0&id=12829677&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12829677",
  null
  
)

export default component.exports